import axios from "axios";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import appConfig from "../../../config";

const JoinZoom = () => {
  const params = useParams<{ sessionId?: string }>();

  const [error, setError] = useState<string>();

  const goBack = () => {
    window.close();
  };

  useEffect(() => {
    if (params?.sessionId) {
      axios
        .post(
          `${appConfig.API_URL}/live_sessions/${params.sessionId}/join_zoom`
        )
        .then(({ status, data }) => {
          if (status === 200 && data.liveSession?.zoomLink?.length) {
            window.location.replace(data.liveSession.zoomLink);
          } else {
            setError(
              "The admin has not set up the zoom link for this session, please try again later."
            );
          }
        });
    } else {
      setError("Please join live session via Access/Join button");
    }
  }, []);

  return (
    <>
      <p className="my-5">{error || "Redirecting you to Zoom session..."}</p>
      <button onClick={goBack} className="btn btn-outline-secondary">
        Close This Tab
      </button>
    </>
  );
};

export default JoinZoom;
